// src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext"; // <-- use the context

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated } = useContext(AuthContext); // listens to state
	console.log(isAuthenticated);

	if (!isAuthenticated) {
		return <Navigate to='/' replace />; // or "/" if that’s your login route
	}

	return children;
};

export default ProtectedRoute;
